module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/smart5-90a915b88134a05f8b4c3190d761c15c.png";